import { Link } from "react-router-dom";

import LegalPageShell from "../components/legal/LegalPageShell";
import { PlanFrequencyTable, PlanLimitTable } from "../components/legal/PlanTable";
import { PLAN_UNLIMITED_NOTE } from "../lib/planCatalog";

export default function TermsPage() {
  return (
    <LegalPageShell>
          <h1 className="text-2xl font-bold text-[#5D4D46]">WizMate 利用規約</h1>

          <p>
            本利用規約（以下「本規約」といいます。）は、株式会社ウィズダムネットワークス（以下「当社」といいます。）が提供する「WizMate」（以下「本サービス」といいます。）の利用条件を定めるものです。ユーザーは、本規約に同意したうえで本サービスを利用するものとします。
          </p>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">第1条（適用）</h2>
            <ol className="list-decimal space-y-2 pl-5">
              <li>本規約は、本サービスの利用に関する当社とユーザーとの間の一切の関係に適用されます。</li>
              <li>当社が本サービス上で掲載する個別規定、ガイドライン、注意事項、料金ページ、申込画面、管理画面その他の表示は、本規約の一部を構成します。</li>
              <li>本規約の内容と個別規定等が異なる場合、個別規定等に特段の定めがない限り、個別規定等が優先して適用されます。</li>
            </ol>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">第2条（定義）</h2>
            <p>本規約において、以下の用語はそれぞれ次の意味を有します。</p>
            <ol className="list-decimal space-y-2 pl-5">
              <li>「ユーザー」とは、本規約に同意し、本サービスを利用する個人または法人をいいます。</li>
              <li>「登録ユーザー」とは、当社所定の方法により利用登録を完了したユーザーをいいます。</li>
              <li>「AI出力」とは、本サービスにおいてAIにより生成される文章、要約、提案、回答、レポートその他の出力をいいます。</li>
              <li>「入力データ」とは、ユーザーが本サービスに入力、送信、アップロード、連携その他の方法により提供する情報をいいます。</li>
              <li>「外部サービス」とは、LINE、Google、Stripeその他の第三者が提供するサービスをいいます。</li>
              <li>「有料プラン」とは、スタンダードプラン、エグゼクティブプランその他当社が有料で提供するプランをいいます。</li>
              <li>「特典コード」とは、当社がキャンペーン、紹介、初期ユーザー向け等に発行する、一定期間または一定範囲で利用条件を拡張するためのコードをいいます。</li>
            </ol>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">第3条（本サービスの内容）</h2>
            <ol className="list-decimal space-y-2 pl-5">
              <li>本サービスは、経営者・事業者等の情報整理、相談、壁打ち、ニュース/レポート配信、調査、資料整理その他の業務支援を目的とするAI支援サービスです。</li>
              <li>本サービスの内容、機能、仕様、利用可能回数、対象プラン等は、当社が別途定めるものとします。</li>
              <li>当社は、必要に応じて本サービスの全部または一部を変更、追加、停止または終了することがあります。</li>
            </ol>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">第4条（利用登録）</h2>
            <ol className="list-decimal space-y-2 pl-5">
              <li>ユーザーは、当社所定の方法により利用登録を申請するものとします。</li>
              <li>
                当社は、以下の場合、利用登録を拒否または取消すことがあります。
                <ol className="mt-2 list-decimal space-y-2 pl-5">
                  <li>登録情報に虚偽、誤記または不足がある場合</li>
                  <li>過去に本規約違反等により利用停止等を受けたことがある場合</li>
                  <li>反社会的勢力等に該当し、または関与していると当社が判断した場合</li>
                  <li>その他、当社が利用登録を適当でないと判断した場合</li>
                </ol>
              </li>
              <li>ユーザーは、登録情報に変更が生じた場合、速やかに当社所定の方法で変更手続きを行うものとします。</li>
            </ol>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">第5条（アカウント管理）</h2>
            <ol className="list-decimal space-y-2 pl-5">
              <li>ユーザーは、自己の責任においてアカウント情報、認証情報、外部サービス連携情報を管理するものとします。</li>
              <li>ユーザーは、アカウントを第三者に利用、貸与、譲渡、売買、名義変更等してはなりません。</li>
              <li>アカウントの管理不十分、使用上の過誤、第三者利用等により生じた損害について、当社は当社の責めに帰すべき場合を除き責任を負いません。</li>
            </ol>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">第6条（プラン、料金および支払）</h2>
            <ol className="list-decimal space-y-2 pl-5">
              <li>本サービスには、フリープラン、スタンダードプラン、エグゼクティブプランその他当社が別途定めるプランがあります。</li>
              <li>
                有料プランの料金は、以下のとおりです。
                <ul className="mt-2 space-y-2 pl-5">
                  <li>・スタンダードプラン：月額3,300円（税込）</li>
                  <li>・エグゼクティブプラン：月額11,000円（税込）</li>
                </ul>
              </li>
              <li>プランごとの利用可能機能、利用回数、上限、対象機能、制限事項は、本サービス上の料金ページ、申込画面または管理画面に表示する内容に従います。</li>
              <li>特典コードが適用される場合、その有効期間、利用可能機能、利用回数、上限その他の条件は、コード適用画面、管理画面または当社が別途表示する条件に従います。</li>
              <li>ユーザーは、有料プランを利用する場合、当社所定の方法により利用料金を支払うものとします。</li>
              <li>決済は、Stripeその他当社が指定する決済代行事業者を通じて行われる場合があります。</li>
              <li>有料プラン申込時に初回決済が行われます。以後、Stripe上のサブスクリプションの請求サイクルに従い、月ごとに自動決済されます。</li>
              <li>ユーザーが支払を遅滞した場合、当社は本サービスの全部または一部の利用を停止することがあります。</li>
              <li>当社は、法令上必要な場合を除き、既に支払われた利用料金を返金しません。</li>
            </ol>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">第7条（利用上限）</h2>
            <ol className="list-decimal space-y-2 pl-5">
              <li>本サービスでは、プランごとに利用可能回数、利用可能枠、配信頻度その他の利用上限を設けることがあります。</li>
              <li>主な利用上限は、以下のとおりです。ただし、当社は本サービスの運営上必要な範囲で、料金ページ、申込画面または管理画面の表示により、これらの上限を変更することがあります。</li>
            </ol>
            <PlanLimitTable />
            <p>※ {PLAN_UNLIMITED_NOTE}</p>
            <p className="font-semibold">定期配信頻度</p>
            <PlanFrequencyTable />
            <ol className="list-decimal space-y-2 pl-5" start={3}>
              <li>実質無制限と表示される機能についても、通常利用の範囲を超える短時間の連続実行、過度な高負荷利用、システム運営に支障を及ぼす利用、その他当社が不適切と判断する利用については、一時的な制限または利用停止を行う場合があります。</li>
              <li>スタンダードプランのレポート定期配信は、毎週または毎月の頻度を対象とし、日次配信はエグゼクティブプランの対象とします。</li>
              <li>ニュースおよびレポートの定期配信枠は、作成できる定期配信設定の数を意味します。実際の配信は、外部情報源、処理状況、重複除外、通知先設定その他の事情により行われない場合があります。</li>
            </ol>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">第8条（解約）</h2>
            <ol className="list-decimal space-y-2 pl-5">
              <li>ユーザーは、本サービス上の管理画面、Stripeが提供する管理画面、または当社所定の方法により有料プランを解約できます。</li>
              <li>月額プランを解約した場合、次回更新日以降の請求は停止されます。</li>
              <li>解約手続き完了後も、既に支払済みの利用期間中は、当該プランを利用できます。</li>
              <li>日割り返金は行いません。</li>
              <li>解約手続きが完了していない場合、契約は自動更新されることがあります。</li>
            </ol>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">第9条（AI出力の性質）</h2>
            <ol className="list-decimal space-y-2 pl-5">
              <li>AI出力は、ユーザーの判断を補助するためのものであり、正確性、完全性、最新性、有用性、適法性、特定目的への適合性を保証するものではありません。</li>
              <li>ユーザーは、AI出力を自己の責任で確認、判断、利用するものとします。</li>
              <li>法律、税務、会計、労務、医療、金融、投資、許認可その他専門的判断を要する事項については、必要に応じて弁護士、税理士、社労士、医師、金融専門家その他の専門家に確認してください。</li>
              <li>AI出力には、事実と異なる情報、古い情報、推測、不完全な情報が含まれる場合があります。</li>
              <li>当社は、AI出力に基づくユーザーの意思決定、行動、取引、損害等について、当社の故意または重過失による場合を除き責任を負いません。</li>
            </ol>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">第10条（ニュース、レポート、調査情報）</h2>
            <ol className="list-decimal space-y-2 pl-5">
              <li>本サービスが提供するニュース、レポート、企業情報、調査結果等は、公開情報、外部情報源、AI処理等に基づき生成される場合があります。</li>
              <li>当社は、これらの情報の正確性、完全性、最新性、網羅性、継続提供を保証しません。</li>
              <li>ユーザーは、重要な意思決定に利用する場合、必ず一次情報、公式情報、専門家の助言等を確認するものとします。</li>
              <li>ニュースおよびレポートの配信は、外部サービス、情報源、通信環境、通知先設定、処理状況等により遅延、失敗、停止または未配信となる場合があります。</li>
            </ol>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">第11条（外部サービス連携）</h2>
            <ol className="list-decimal space-y-2 pl-5">
              <li>本サービスは、LINE、Google、Stripeその他の外部サービスと連携する場合があります。</li>
              <li>外部サービスの利用については、各外部サービスの利用規約、プライバシーポリシーその他の条件が適用されます。</li>
              <li>外部サービスの仕様変更、停止、不具合、アカウント制限等により本サービスの全部または一部が利用できなくなる場合があります。</li>
              <li>当社は、外部サービスに起因する損害について、当社の責めに帰すべき場合を除き責任を負いません。</li>
            </ol>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">第12条（入力データ）</h2>
            <ol className="list-decimal space-y-2 pl-5">
              <li>ユーザーは、入力データについて、必要な権利、権限、同意を有していることを保証します。</li>
              <li>ユーザーは、第三者の機密情報、個人情報、著作物その他の情報を入力する場合、自己の責任において適切な権限確認および管理を行うものとします。</li>
              <li>当社は、本サービスの提供、改善、保守、不具合対応、セキュリティ確保、利用状況分析のために、必要な範囲で入力データを取り扱うことがあります。</li>
              <li>
                個人情報の取扱いについては、当社の
                <Link to="/privacy" className="underline underline-offset-4">
                  プライバシーポリシー
                </Link>
                に従います。
              </li>
            </ol>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">第13条（禁止事項）</h2>
            <p>ユーザーは、本サービスの利用にあたり、以下の行為をしてはなりません。</p>
            <ol className="list-decimal space-y-2 pl-5">
              <li>法令または公序良俗に違反する行為</li>
              <li>犯罪行為またはこれを助長する行為</li>
              <li>当社、他のユーザー、第三者の権利または利益を侵害する行為</li>
              <li>虚偽、不正確、誤解を招く情報を入力または送信する行為</li>
              <li>第三者の個人情報、機密情報、営業秘密等を不適切に入力または利用する行為</li>
              <li>本サービスを不正アクセス、攻撃、解析、過度な負荷、リバースエンジニアリング等に利用する行為</li>
              <li>AI出力を、法令違反、差別、誹謗中傷、詐欺、迷惑行為、危険行為その他不適切な目的で利用する行為</li>
              <li>本サービスの運営を妨害する行為</li>
              <li>当社の事前承諾なく、本サービスまたはAI出力を第三者に再販売、再提供、商用代行利用する行為</li>
              <li>その他、当社が不適切と判断する行為</li>
            </ol>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">第14条（知的財産権）</h2>
            <ol className="list-decimal space-y-2 pl-5">
              <li>本サービスに関する著作権、商標権、ノウハウ、プログラム、デザイン、文章、画像その他一切の知的財産権は、当社または正当な権利者に帰属します。</li>
              <li>ユーザーは、本規約に基づく範囲で本サービスを利用する権利を有するにとどまり、本サービスに関する知的財産権を取得するものではありません。</li>
              <li>ユーザーが本サービスに入力した入力データに関する権利は、ユーザーまたは正当な権利者に留保されます。</li>
              <li>AI出力の利用可否、権利関係、第三者権利侵害の有無については、ユーザーの責任で確認するものとします。</li>
            </ol>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">第15条（サービスの停止・中断）</h2>
            <p>当社は、以下の場合、本サービスの全部または一部を停止または中断することがあります。</p>
            <ol className="list-decimal space-y-2 pl-5">
              <li>システムの保守、点検、更新を行う場合</li>
              <li>障害、事故、通信回線、クラウドサービス、外部サービス等の不具合が発生した場合</li>
              <li>天災地変、停電、戦争、暴動、法令改正、行政指導その他不可抗力が発生した場合</li>
              <li>セキュリティ上の理由により必要がある場合</li>
              <li>その他、当社が停止または中断を必要と判断した場合</li>
            </ol>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">第16条（利用停止・登録抹消）</h2>
            <p>当社は、ユーザーが以下のいずれかに該当する場合、事前通知なく、本サービスの利用停止、アカウント停止、登録抹消その他必要な措置を行うことがあります。</p>
            <ol className="list-decimal space-y-2 pl-5">
              <li>本規約に違反した場合</li>
              <li>登録情報に虚偽がある場合</li>
              <li>支払遅延または決済不能が発生した場合</li>
              <li>長期間利用がない場合</li>
              <li>当社からの連絡に対して一定期間応答がない場合</li>
              <li>その他、当社が本サービスの利用継続を適当でないと判断した場合</li>
            </ol>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">第17条（保証の否認）</h2>
            <ol className="list-decimal space-y-2 pl-5">
              <li>当社は、本サービスがユーザーの特定目的に適合すること、期待する成果を得られること、正確性、完全性、継続性、可用性、安全性、不具合がないことを保証しません。</li>
              <li>当社は、本サービスにより生成、表示、配信される情報が常に最新または正確であることを保証しません。</li>
              <li>当社は、外部サービス、通信環境、端末、ブラウザ、OS等に起因する不具合について責任を負いません。</li>
            </ol>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">第18条（損害賠償および責任制限）</h2>
            <ol className="list-decimal space-y-2 pl-5">
              <li>当社がユーザーに対して損害賠償責任を負う場合、その範囲は、当社の故意または重過失による場合を除き、当該損害発生時点から過去1か月間にユーザーが当社に支払った利用料金の総額を上限とします。</li>
              <li>当社は、特別損害、間接損害、逸失利益、事業機会の喪失、データ消失、信用毀損等について、当社の故意または重過失による場合を除き責任を負いません。</li>
              <li>消費者契約法その他法令により本条の一部が無効となる場合でも、当社の責任は法令上許される範囲に限定されます。</li>
            </ol>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">第19条（反社会的勢力の排除）</h2>
            <ol className="list-decimal space-y-2 pl-5">
              <li>ユーザーは、自己またはその役職員、関係者が反社会的勢力に該当しないこと、反社会的勢力と関係を有しないことを表明し保証します。</li>
              <li>ユーザーが前項に違反した場合、当社は事前通知なく利用停止、契約解除その他必要な措置を行うことができます。</li>
            </ol>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">第20条（規約の変更）</h2>
            <ol className="list-decimal space-y-2 pl-5">
              <li>当社は、法令に従い、本規約を変更することがあります。</li>
              <li>当社は、本規約を変更する場合、変更後の内容および効力発生日を、本サービス上への掲載その他当社が適切と判断する方法により周知します。</li>
              <li>変更後にユーザーが本サービスを利用した場合、ユーザーは変更後の本規約に同意したものとみなされます。</li>
            </ol>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">第21条（通知・連絡）</h2>
            <ol className="list-decimal space-y-2 pl-5">
              <li>当社からユーザーへの通知は、本サービス上の表示、電子メール、LINE、その他当社が適切と判断する方法により行います。</li>
              <li>ユーザーから当社への連絡は、当社所定の問い合わせ方法により行うものとします。</li>
            </ol>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">第22条（権利義務の譲渡禁止）</h2>
            <p>ユーザーは、当社の事前の書面による承諾なく、本規約上の地位または本規約に基づく権利義務を第三者に譲渡、移転、担保設定その他処分することはできません。</p>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">第23条（分離可能性）</h2>
            <p>本規約の一部が法令または裁判所により無効または執行不能と判断された場合でも、その他の部分は継続して有効に存続します。</p>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">第24条（準拠法・管轄）</h2>
            <ol className="list-decimal space-y-2 pl-5">
              <li>本規約の準拠法は日本法とします。</li>
              <li>本サービスに関して当社とユーザーとの間で紛争が生じた場合、当社所在地を管轄する地方裁判所または簡易裁判所を第一審の専属的合意管轄裁判所とします。</li>
            </ol>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">第25条（問い合わせ）</h2>
            <p>本規約に関する問い合わせ先は、以下のとおりです。</p>
            <p>株式会社ウィズダムネットワークス</p>
            <p>
              <a href="mailto:wizmate@wisdomnetworks.co.jp" className="underline underline-offset-4">
                wizmate@wisdomnetworks.co.jp
              </a>
            </p>
          </section>

          <p>制定日：2026年6月29日</p>
    </LegalPageShell>
  );
}
